import React from 'react';
import { Play, MoreHorizontal } from 'lucide-react';
import { Card, CardContent } from './ui/Card';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
export interface VideoCardProps {
  title: string;
  thumbnail: string;
  duration: string;
  topic: string;
  feel: string[];
}
export function VideoCard({
  title,
  thumbnail,
  duration,
  topic,
  feel
}: VideoCardProps) {
  return <Card className="group overflow-hidden border-gray-200 hover:shadow-lg transition-all duration-300 bg-white h-full flex flex-col" data-id="element-654">
      {/* Thumbnail Section - 9:16 aspect ratio */}
      <div className="relative bg-gray-100 overflow-hidden" style={{
      aspectRatio: '9/16'
    }} data-id="element-655">
        <img src={thumbnail} alt={title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-656" />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100" data-id="element-657">
          <div className="h-12 w-12 rounded-full bg-white/90 flex items-center justify-center shadow-lg transform scale-90 group-hover:scale-100 transition-all" data-id="element-658">
            <Play className="h-5 w-5 text-[#139191] ml-1" fill="#139191" data-id="element-659" />
          </div>
        </div>
        <div className="absolute bottom-2 right-2 px-2 py-1 bg-black/70 rounded text-[10px] font-medium text-white" data-id="element-660">
          {duration}
        </div>
      </div>

      {/* Content Section */}
      <CardContent className="p-4 flex-1" data-id="element-661">
        <div className="flex justify-between items-start gap-2 mb-3" data-id="element-662">
          <Badge variant="secondary" className="bg-[#139191] text-white hover:bg-[#139191]/90 border-none font-medium px-2.5" data-id="element-663">
            {topic}
          </Badge>
          <Button variant="ghost" size="icon" className="h-6 w-6 -mr-2 text-gray-400 hover:text-gray-600" data-id="element-664">
            <MoreHorizontal className="h-4 w-4" data-id="element-665" />
          </Button>
        </div>

        <h3 className="font-bold text-lg leading-tight text-gray-900 mb-2 line-clamp-2 group-hover:text-[#139191] transition-colors" data-id="element-666">
          {title}
        </h3>

        <div className="flex flex-wrap gap-1.5 mt-3" data-id="element-667">
          {feel.map(tag => <Badge key={tag} variant="outline" className="text-xs font-normal text-gray-600 border-gray-200 bg-gray-50" data-id="element-668">
              {tag}
            </Badge>)}
        </div>
      </CardContent>
    </Card>;
}